import { PressLandingPageWrapperLazy } from './pressLandingPageWrapperLazy';

const props = [];

export const PressLandingPageWrapperDirective = reactDirective => reactDirective(PressLandingPageWrapperLazy, props);
PressLandingPageWrapperDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('pressLandingPageWrapper', PressLandingPageWrapperDirective);
